import { motion } from 'framer-motion';
import { FC, JSX } from 'react';
import { LinkAction } from './LinkAction';

export interface SideMenuOption {
  icon?: JSX.Element;
  label: string;
  element?: JSX.Element;
  anchorId: string;
}

interface VerticalMenuProps {
  onTabSelect?: (tab: string) => void;
  sideMenuOptions: SideMenuOption[];
  allElements?: JSX.Element;
  isScroll?: boolean;
  selectedTab?: string;
}

export const VerticalMenu: FC<VerticalMenuProps> = ({
  onTabSelect,
  sideMenuOptions,
  allElements,
  isScroll,
  selectedTab
}) => {
  const activeIndex = sideMenuOptions.findIndex(opt => opt.anchorId === selectedTab);
  const tabIndex = activeIndex === -1 ? 0 : activeIndex;

  const handleTabClick = (tab: string) => {
    onTabSelect && onTabSelect(tab);
  };

  const menuItems = sideMenuOptions.map(({ icon, label, anchorId }, idx: number) => {
    const isActive = tabIndex === idx;

    const tabMenuItems = (
      <div className="flex flex-col min-w-[165px]" key={`${anchorId}-${idx}`}>
        <LinkAction
          key={label}
          active={isActive}
          onClick={() => {
            handleTabClick(anchorId);
          }}
        >
          <span>{icon}</span>
          <span>{label}</span>
        </LinkAction>
        {isActive && (
          <motion.div
            className="bg-primary-500 w-full h-[5px] rounded-b-lg"
            layoutId={`vertical-tab-active`}
            transition={{ type: 'spring', stiffness: 500, damping: 25 }}
          />
        )}
      </div>
    );

    const scrollMenuItems = (
      <div className="flex flex-col min-w-[165px]" key={`${anchorId}-${idx}`}>
        <LinkAction href={`#${anchorId}`}>
          <span>{icon}</span>
          <span>{label}</span>
        </LinkAction>
      </div>
    );

    return isScroll === true ? scrollMenuItems : tabMenuItems;
  });

  return (
    <>
      <div className="w-full sm:w-max flex flex-row lg:flex-col gap-2 mb-4 overflow-auto sm:overflow-visible">
        {menuItems}
      </div>
      <div className="space-y-3 flex-1">{isScroll === true ? allElements : sideMenuOptions[tabIndex].element}</div>
    </>
  );
};
